import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';

const Screen = lazy(() =>
  import('../screens/Grants/GrantsScreen').then(m => ({ default: m.GrantsScreen })),
);

export const Route = createFileRoute('/grants')({
  component: () => (
    <Suspense fallback={<div style={{ padding: 32, color: 'var(--lca-gray-500)', fontSize: 13 }}>Loading…</div>}>
      <Screen />
    </Suspense>
  ),
});
